import { Badge } from '@/components/ui/badge';

export function EnvironmentBadges({ environments = [] }) {
  return (
    <div className="flex flex-wrap gap-1">
      {environments.map((environment) => (
        <EnvironmentBadge
          key={environment.id || environment.environment}
          value={environment.environment}
          available={environment.provision_eligible}
          connected={environment.connection_available}
          title={environment.connection_available ? environment.connection_reason : environment.provision_reason}
        />
      ))}
    </div>
  );
}

export function EnvironmentBadge({ value, available = false, connected = false, title }) {
  const className = connected
    ? 'border-success/25 bg-success/10 font-mono uppercase text-success'
    : available
      ? 'border-primary/25 bg-primary/10 font-mono uppercase text-primary'
      : 'font-mono uppercase text-muted-foreground';
  return <Badge variant="outline" className={className} title={title}>{value}</Badge>;
}

export function StatusBadge({ value }) {
  const normalized = value?.toLowerCase() || '';
  const isPositive = ['activ', 'salud', 'complet', 'disponible', 'aprob', 'aprovisionada'].some((term) => normalized.includes(term));
  const isNegative = ['alert', 'crít', 'fall', 'rechaz', 'bloquead', 'no disponible'].some((term) => normalized.includes(term));
  const className = isPositive
    ? 'border-success/25 bg-success/10 text-success'
    : isNegative
      ? 'border-destructive/25 bg-destructive/10 text-destructive'
      : 'border-warning/25 bg-warning/10 text-warning';
  return <Badge variant="outline" className={className}>{value || 'Desconocido'}</Badge>;
}
